import admins from "../helpers/adminsList";

function Admin(props) {
    return (
        <li className="team-item">
            <img src={`./img/admins/${props.img}.png`} alt="" />
            <div className="admin-text">
                <h3>@{props.dm}</h3>
                <p>{props.text}</p>
            </div>
        </li>
    );
}

export default function Team() {
    return (
        <main>
            <div className="container">
                <h2 className="team-header">Наша команда</h2>
                <ul className="team-list">
                    {
                        admins.map((e, index) => {
                            return <Admin key={index} img={e.img} dm={e.dm} text={e.text} />
                        })
                    }
                </ul>
            </div>
        </main>
    );
}